import { drivelabels_v2 } from '@googleapis/drivelabels';
import { getLabelLifecycleStatus } from './label-lifecycle';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

export function isLabelEnableable(label: Label) {
  return getLabelLifecycleStatus(label) === 'DISABLED';
}

export function hasUnenableableLabel(labels: Label[]) {
  return labels.some((label) => !isLabelEnableable(label));
}
